import { PaginationTable } from '../../../common';

const SubscribersPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <PaginationTable
      totalPages={totalPages}
      totalCount={totalCount}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
};

export default SubscribersPagination;
